import { isPlatformBrowser, Location } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { SubSink } from 'subsink';
import { RouterPathConfig } from '../../constants/router-path.config';
import { USER_ROLE } from '../../constants/user-role.enum';
import { ApiRequestService } from '../../services/api-request.service';
import { AuthService } from '../../services/auth.service';
import { LoggedInUserService } from '../../services/logged-in-user.service';
import { RoutingHandlerService } from '../../services/routing-handler.service';
import { SidebarMenuService } from '../../services/sidebar-menu.service';
import { TranslateService } from '../../translate';
import { TuwaiqUtil } from '../../TuwaiqUtil';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss', './header.responsive.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
    isHome: boolean = false;
    menuList = [{ id: 5, name: 'requests', path: '/admin/new-requests' }];
    selectedItem = this.menuList[0];
    subs = new SubSink();
    loggedInUserDetails;
    userRole;
    userRoleName: string;
    checked: boolean;
    userRoleEmpolyee = USER_ROLE.EMPLOYEE;
    userRoleEmpolyeeOperation = USER_ROLE.OPERATION_EMPLOYEE;
    languages = this.translateService.languages;
    otherLang$ = this.translateService.otherLang$;
    isWebView: boolean = false;

    statusText: string;
    constructor(
        private authService: AuthService,
        private sidebarMenuService: SidebarMenuService,
        private routingHandlerService: RoutingHandlerService,
        private location: Location,
        private cookies: CookieService,
        @Inject(PLATFORM_ID) private platformId: Object,
        private router: Router,
        private loggedInUserService: LoggedInUserService,
        private apiRequestService: ApiRequestService,
        private readonly translateService: TranslateService
    ) {
        this.userRole = this.loggedInUserService.getUserRole();
        this.isHome = this.router.url.includes(RouterPathConfig.HOME_PATH);
        this.subs.sink = this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.isHome = event.url.includes(RouterPathConfig.HOME_PATH);
            }
        });
    }
    isShowDivIf = true;
    toggleDisplayDivIf() {
        this.isShowDivIf = !this.isShowDivIf;
    }

    ngOnInit(): void {
        this.isWebView = TuwaiqUtil.isWebView();
        this.userRole = this.loggedInUserService.getUserRole();
        this.userRoleName = this.getUserRoleName();

        this.getViewAndLoggedInUserDetails();
        this.addItemsToMenuBasedOnRole();
        this.storeSuperAdminMenuItem();
        this.addFileManagementMenuItem();
        this.addPeriodicReviewMenuItem()

        this.handleHeaderMenuList();
        this.subscribeToRouterChangeSetActiveHeaderMenu();
    }

    public switchLang(lang: string) {
        this.translateService.changeLang(lang);
        this.router.navigateByUrl('/reload-data');
    }

    getUserRoleName() {
        return this.userRole.replaceAll('_', ' ').substring(5, this.userRole.length).toLowerCase();
    }

    handeleStatus() {
        if (this.loggedInUserDetails.status === 'AVAILABLE') {
            this.checked = true;
            this.statusText = 'active';
        } else {
            this.checked = false;
            this.statusText = 'notActive';
        }
    }
    addItemsToMenuBasedOnRole() {
        const userPath = this.routingHandlerService.getUserPathFromRole(this.userRole);
        //if (this.userRole !== USER_ROLE.REQUESTER && this.userRole !== USER_ROLE.ACCOUNT_MANAGER) {

        if (!this.loggedInUserService.isAccountMangerOrRequester()) {
            this.menuList.unshift({ id: 2, name: 'strategy', path: '/strategy' });
        }
        // this.userRole === USER_ROLE.ADMIN ||
        // this.loggedInUserService.isSuperAdmin() ||
        // this.userRole === USER_ROLE.SHIFT_MANAGER ||
        // this.userRole === USER_ROLE.SECTION_MANAGER ||
        // this.userRole === USER_ROLE.EMPLOYEE ||
        // this.userRole === USER_ROLE.REQUESTER ||
        // this.userRole === USER_ROLE.STS_EMPLOYEE ||
        // this.userRole === USER_ROLE.ACCOUNT_MANAGER ||
        // this.userRole === USER_ROLE.OPERATION_SHIFT_MANAGER ||
        // this.userRole === USER_ROLE.OPERATION_EMPLOYEE||
        // this.userRole === USER_ROLE.GENERAL_MANAGER||
        // this.userRole === USER_ROLE.DIRECTOR||

        // if (this.loggedInUserService.isAllUser()
        // ) {
        this.menuList.unshift({ id: 0, name: 'home', path: '/home' });
        //}

        // this.userRole === USER_ROLE.ADMIN ||
        // this.loggedInUserService.isSuperAdmin() ||
        // this.userRole === USER_ROLE.SECTION_MANAGER ||
        // this.userRole === USER_ROLE.ACCOUNT_MANAGER

        if (this.loggedInUserService.canSeeDashboard()) {
            this.menuList.push({ id: 1, name: 'dashboard', path: `/${userPath}/dashboard` });
        }

        // this.userRole !== USER_ROLE.REQUESTER && this.userRole !== USER_ROLE.ACCOUNT_MANAGER

        if (!this.loggedInUserService.isAccountMangerOrRequester()) {
            this.menuList.push({ id: 6, name: 'serviceCatalog', path: '/serviceCatalog' });
        }
        // this.loggedInUserService.isSuperAdmin() ||
        // this.userRole === USER_ROLE.ADMIN ||
        // this.userRole === USER_ROLE.SHIFT_MANAGER ||
        // this.userRole === USER_ROLE.SECTION_MANAGER ||
        // this.userRole === USER_ROLE.OPERATION_SHIFT_MANAGER

        if (this.loggedInUserService.isDisplaySeenEmployeeManagement()) {
            this.menuList.push({ id: 7, name: 'empolyeeManagement', path: '/empolyee-managment' });
        }
        //this.userRole === USER_ROLE.ACCOUNT_MANAGER

        if (this.loggedInUserService.isAccountMangerInquires()||this.loggedInUserService.isAccountMangertBoth()) {
            this.menuList.push({ id: 8, name: 'clientManagementUsers', path: '/client-management-users' });
        }
        if (this.loggedInUserService.isDisplayEServices()) {
            this.menuList.push({ id: 12, name: 'eServices', path: '/services' });
        }

        if (this.loggedInUserService.canAccessMessageCenter()) {
            this.menuList.push({ id: 9, name: 'ticketing', path: '/ticketing' });
        }
        //this.userRole === USER_ROLE.STS_EMPLOYEE
        if (this.loggedInUserService.cannotSeeInquiries()) {
            const index = this.menuList.findIndex(menuItem => menuItem.id === 5 && menuItem.name === 'requests');
            if (index > -1) {
                this.menuList.splice(index, 1);
            }
        }
    }

    storeSuperAdminMenuItem() {
        if (this.loggedInUserService.isSuperAdmin()) {
            this.menuList.push(RouterPathConfig.dataManagmentRoute);
        }
    }

    addFileManagementMenuItem() {
        if (this.loggedInUserService.isInternalUser()) {
            this.menuList.push(RouterPathConfig.fileManagmentRoute);
        }
    }

    addPeriodicReviewMenuItem() {
        if ((this.loggedInUserService.isInternalUser())) {
            if(this.loggedInUserService.canAccessReports()||this.loggedInUserService.isInternalUsercanAccessReports())
            this.menuList.push(RouterPathConfig.periodicReviewReportRoute);
        else
        this.menuList.push(RouterPathConfig.periodicReviewSharedReportRoute);

        }
    }
    handleHeaderMenuList() {
        const urlWithOutParams = this.location.path().split('?')[0];
        const getUserPathFromURL = urlWithOutParams.trim().split('/')[1];
        this.resetRequestsPath();

        if (this.loggedInUserService.isSuperAdmin() && getUserPathFromURL === RouterPathConfig.DATA_MANAGEMENT) {
            this.selectedItem = this.menuList.find(item => item.id === 4);
        } else if (this.loggedInUserService.isInternalUser() && getUserPathFromURL === RouterPathConfig.FILE_MANAGEMENT) {
            this.selectedItem = this.menuList.find(item => item.id === 10);}
            else if (this.loggedInUserService.isInternalUser() && getUserPathFromURL === RouterPathConfig.PERIODIC_REVIEW) {
                this.selectedItem = this.menuList.find(item => item.id === 11);
                if(urlWithOutParams==='/periodic-review/shared-reports'){
                    this.selectedItem.path='periodic-review/shared-reports'
                 } 
                else if(urlWithOutParams==='/periodic-review/reports'){
                    this.selectedItem.path='periodic-review/reports'

                }             
                  
        } else if ((!getUserPathFromURL || getUserPathFromURL === RouterPathConfig.HOME_PATH) && (this.loggedInUserService.isSuperAdmin() || this.isAdmin())) {
            this.selectedItem = this.menuList[0];
        } else if (getUserPathFromURL === RouterPathConfig.STRATEGY) {
            this.selectedItem = this.menuList.find(item => item.id === 2);
        } else if (
            urlWithOutParams.includes(RouterPathConfig.REQUEST_PATH.NEW_REQUESTS) ||
            urlWithOutParams.includes(RouterPathConfig.REQUEST_PATH.ASSIGNED_TO_ME_REQUESTS) ||
            urlWithOutParams.includes(RouterPathConfig.REQUEST_PATH.COMPLETED_REQUESTS) ||
            urlWithOutParams.includes(RouterPathConfig.REQUEST_PATH.INPROGRESS_REQUESTS) ||
            urlWithOutParams.includes(RouterPathConfig.REQUEST_PATH.RETURNED_REQUESTS) ||
            urlWithOutParams.includes(RouterPathConfig.REQUEST_PATH.EMPLOYEE_MANAGEMENT_REQUESTS) ||
            urlWithOutParams.includes(RouterPathConfig.REQUEST_PATH.COMPLETED_HISTORY_REQUESTS) ||
            urlWithOutParams.includes(RouterPathConfig.REQUEST_PATH.TECHNICAL_OPERATIONS_REQUESTS)
        ) {
            this.selectedItem = this.menuList.find(item => item.id === 5);
            this.selectedItem.path = urlWithOutParams;
        } else {
            this.selectedItem = this.menuList.find(item => item.id === 1);
        }
        this.sidebarMenuService.storeActiveHeaderMenuItem(this.selectedItem);
    }

    subscribeToRouterChangeSetActiveHeaderMenu() {
        this.subs.sink = this.routingHandlerService.onRouterChangeSetActiveHeaderMenu.subscribe(() => {
            this.handleHeaderMenuList();
        });
    }

    getViewAndLoggedInUserDetails() {
        this.loggedInUserDetails = this.loggedInUserService.getLoggedInUserDetails();
        this.handeleStatus();
    }

    onMenuClick(selectedItem: any) {
        var nav = document.getElementsByClassName('responsive__active');
        if (nav.length > 0) this.isShowDivIf = !this.isShowDivIf;
        this.resetRequestsPath();
        this.selectedItem = selectedItem;
        this.routingHandlerService.navigateTo(selectedItem.path);
        this.sidebarMenuService.storeActiveHeaderMenuItem(selectedItem);
    }

    resetRequestsPath() {
        const userPath = this.routingHandlerService.getUserPathFromRole(this.userRole);
        let item = this.menuList.find(item => item.id === 5);
        if (item) {
            item.path = '/' + userPath + '/new-requests';
        }
    }

    onLogout() {
        this.apiRequestService.empolyeeUNAvailable().subscribe(response => {});
        this.authService.logout();
    }

    isAdmin() {
        if (isPlatformBrowser(this.platformId)) {
            return this.cookies.get('userRole') === USER_ROLE.ADMIN;
        } else {
            return null;
        }
    }

    ngOnDestroy(): void {
        this.subs.unsubscribe();
    }
    change(e: any) {
        const value = e.checked;
        if (value == true) {
            this.statusText = 'active';
            this.checked = true;
            this.apiRequestService.empolyeeAvailable().subscribe(response => {});
        } else {
            this.statusText = 'notActive';
            this.checked = false;

            this.apiRequestService.empolyeeUNAvailable().subscribe(response => {});
        }
    }
}